/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CreateActionsDropdown } from "shared/dropdowns/CreateActionsDropdown";
import { Button, IconDispatcher } from "shared/ui-basics";
import { FlexBetween, FlexContainer } from "./cx-components.style";
import { useInsertRecentWork } from "shared/hooks";

type HeaderProps = {
	onClose: () => void;
	actions: any[];
	navigationList: string[];
	currentItemId: string;
	setCurrentItem: (currentItemId: string) => void;
	showCopyUrl?: boolean;
	entityName?: string;
	disabled?: boolean;
};

const Header: React.FC<HeaderProps> = ({ onClose, actions, navigationList, currentItemId, setCurrentItem, showCopyUrl = true, entityName, disabled }: HeaderProps) => {
	const { t } = useTranslation();

	useInsertRecentWork({
		entityName,
		recordId: currentItemId,
	});

	const currentIndex = navigationList?.findIndex((item) => item === currentItemId);
	const disableUp = currentIndex === 0;
	const disableDown = currentIndex === navigationList?.length - 1;
	const noNavigation = navigationList?.length === 0;

	const handleNavigationUp = () => {
		const id = navigationList[currentIndex - 1];
		setCurrentItem(id);
	};
	const handleNavigationDown = () => {
		const id = navigationList[currentIndex + 1];
		setCurrentItem(id);
	};
	const copyUrl = () => {
		navigator.clipboard.writeText(window.location.href + "?id=" + currentItemId);
		toast.success(t("URL_COPIED"));
	};
	const getActions = () => {
		if (showCopyUrl) return [{ id: "link", icon: "LINK", text: t("URL_LINK"), handleClick: copyUrl }, ...actions];
		return [...actions];
	};

	const actualActions = getActions();
	return (
		<FlexBetween>
			<FlexContainer gap={8}>
				{noNavigation || (disableUp && disableDown) ? null : (
					<>
						<Button variant="light-link" className="px-1" size="xs" onClick={handleNavigationUp} disabled={disableUp}>
							{IconDispatcher("chevron-up")}
						</Button>
						<Button variant="light-link" className="px-1" size="xs" onClick={handleNavigationDown} disabled={disableDown}>
							{IconDispatcher("chevron-down")}
						</Button>
					</>
				)}
				{!disabled && actualActions?.length > 0 && CreateActionsDropdown({ actions: actualActions, variant: "none", dropdownClasses: "px-0", size: "xs" })}
			</FlexContainer>
			<Button variant="light-link" size="xs" onClick={onClose}>
				{IconDispatcher("x", "", { size: "small" })}
			</Button>
		</FlexBetween>
	);
};

export default Header;
